import { environment } from '../../../../../environments/environment';
// import * as angular from 'angular';

(function () {
  'use strict';

  angular.module('app').service('TourOptionScheduleService', TourOptionScheduleService);

  TourOptionScheduleService.$inject = [
    'RestResource',
    'CONFIGURATIONS',
    '$translate',
    '$filter',
    'UtilService',
    'ModalWindowConfirmService',
  ];

  function TourOptionScheduleService(
    RestResource,
    config,
    $translate,
    $filter,
    UtilService,
    ModalWindowConfirmService
  ) {
    var utils = new UtilService(this);

    $translate = $filter('translate');

    var apiUrl = environment.apiEndpoint + 'tours';

    var service = {
      changeTourOptionScheduleStatus: changeTourOptionScheduleStatus,
      deleteTourOptionSchedule: deleteTourOptionSchedule,
    };

    return service;

    ////////////////

    function changeTourOptionScheduleStatus(tourId, tourOptionId, schedule, successCallback) {
      var url = `${apiUrl}/${tourId}/tour_options/${tourOptionId}/tour_option_schedules/${schedule.id}`;

      var ACTIVE = config.ACTIVE;
      var INACTIVE = config.INACTIVE;

      schedule.status = schedule.status === ACTIVE ? INACTIVE : ACTIVE;

      return RestResource.request(
        'put',
        url,
        { status: schedule.status },
        function (response) {
          utils._successMsg($translate('SCHEDULE_MODIFIED'));

          return successCallback(response.data);
        },
        function () {}
      );
    }

    function deleteTourOptionSchedule(tourId, tourOptionId, schedule, successCallback, index) {
      var modalParams = {
        mode: 'danger',
        title: 'SURE_TO_DELETE_SCHEDULE',
        reason: 'DELETE_ITEM_REASON',
        confirmButtonLabel: 'DELETE_SCHEDULE',
      };

      var confirmCallback = function (reasonStatus) {
        var url = `${apiUrl}/${tourId}/tour_options/${tourOptionId}/tour_option_schedules/${schedule.id}`;

        function success(response) {
          var msg = $translate('DELETED_SCHEDULE');
          utils._successMsg(msg);

          return successCallback(index, response.data);
        }
        function failure(response) {
          utils._errorMsg(response.data.error);
        }

        return RestResource.request(
          'delete',
          url,
          { reason_status: reasonStatus },
          success,
          failure
        );
      };

      ModalWindowConfirmService.open(modalParams, confirmCallback);
    }
  }
})();
